import React from "react";

export function ConversationListSkeleton() {
  return (
    <div className="flex flex-col h-full border-r border-border bg-background w-[250px]">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="h-6 w-32 bg-muted rounded animate-pulse" />
          <div className="h-8 w-8 bg-muted rounded animate-pulse" />
        </div>
      </div>
      <div className="flex-1 p-2 space-y-1">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="rounded-lg p-3">
            <div className="flex items-start gap-2">
              <div className="h-4 w-4 bg-muted rounded animate-pulse flex-shrink-0 mt-0.5" />
              <div className="flex-1 space-y-2">
                <div className="flex items-center justify-between gap-2">
                  <div className="h-4 w-24 bg-muted rounded animate-pulse" />
                  <div className="h-4 w-6 bg-muted rounded animate-pulse" />
                </div>
                <div className="h-3 w-full bg-muted rounded animate-pulse" />
                <div className="h-3 w-16 bg-muted rounded animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}